import {Pipe, PipeTransform} from '@angular/core';
import {Match} from '../model/events/Match';

@Pipe({standalone: true, name: 'matchResultFullPipe'})
export class MatchResultFullPipe implements PipeTransform
{
  transform(match: Match): string
  {
    if (match)
    {
      let s = '';
      const hasSets = match.setsHome > 0 || match.setsAway > 0;

      if (hasSets)
      {
        s += match.setsHome + '-' + match.setsAway;

        if (match.legsPerSetHome && match.legsPerSetAway)
        {
          const homeSplit = match.legsPerSetHome.split(';');
          const awaySplit = match.legsPerSetAway.split(';');
          if (homeSplit && awaySplit && homeSplit.length === awaySplit.length)
          {
            s += ' (';
            for (let i = 0; i < homeSplit.length; i++)
            {
              if (i > 0)
                s += ' | ';
              s += homeSplit[i] + '-' + awaySplit[i];
            }
            s += ')';
          }
        }
        else if (match.legsHome > 0 || match.legsAway > 0)
        {
          s += ' (' + match.legsHome + '-' + match.legsAway + ')';
        }
      }
      else if (match.legsHome > 0 || match.legsAway > 0)
      {
        s += match.legsHome + '-' + match.legsAway;
      }

      if (s === '')
        return '-';
      return s;
    }
    return '-';
  }
}
